import {db} from "../firebase";
import {Collections} from "./collections";
import {SchoolInterface} from "../db/models/school";
import {RoleEnum} from "../db/models/role";
import {UserInterface} from "../db/models/user";
import {getUid} from "./auth";
import {uploadMediaToStorage} from "./storage";

export const getSchoolById = (uid: string): Promise<SchoolInterface | null> => {
    if (!uid) return Promise.resolve(null);

    return db
        .collection(Collections.USERS)
        .doc(uid)
        .get()
        .then((doc) => {
            const user = doc.data() as UserInterface;
            const role = user?.role || null;

            if (role === RoleEnum.School) return user as SchoolInterface;
            else return null;
        })
        .catch(error => {
            return Promise.resolve(null);
        })
};

export const getSchools = async (): Promise<SchoolInterface[]> => {
    try {
        const snapshot = await db
            .collection(Collections.USERS)
            .where("role", "==", RoleEnum.School)
            .get();

        let res: SchoolInterface[] = [];
        snapshot.forEach((doc) => res.push(doc.data() as SchoolInterface));
        return await Promise.resolve(res);
    } catch (error) {
        return Promise.reject("get error");
    }
};

export const updateSchoolLogoDocAndMedia = (file: any) => {
    const uid = getUid();
    if (!file || !uid) return Promise.reject("bad params");

    const docRef = db.collection(Collections.USERS).doc(uid);
    const storagePath = `${uid}/profile/logo`;

    return uploadMediaToStorage(file, storagePath).then((downloadUrl: string) => {
        const partialSchool: Partial<SchoolInterface> = {
            logoUrl: downloadUrl
        }
        return docRef.update(partialSchool);
    });
};